/**
 * Keefla — ürün kartı galerisi (koleksiyon/ürünler ızgarası).
 *
 * Ne yapar:
 *  1) Kart içindeki yatay kaydırmalı fotoğraf şeridini yönetir — mobilde
 *     parmakla kaydırılır (native scroll-snap, ekstra kütüphane yok).
 *  2) Altındaki noktaları (hangi fotoğraftayız) kaydırmayla senkron tutar.
 *  3) Renk kutucuğuna tıklanınca o rengin fotoğrafına kaydırır
 *     (swatch input'undaki data-image-id ↔ slayttaki data-image-id).
 *  4) Masaüstünde karta hover'layınca 2. fotoğrafa geçer, ayrılınca
 *     ilkine döner (eski "hover'da ikinci görsel" davranışının karşılığı).
 *  5) Parmakla kaydırdıktan hemen sonra kartın linkinin tetiklenip
 *     yanlışlıkla ürün sayfasına gitmesini engeller.
 *
 * NOT (aktif slayt tespiti): İlk sürümde IntersectionObserver kullanılmıştı,
 * ama bu hem gereksiz karmaşık hem de bazı bağlamlarda (ör. arka plandaki
 * sekme, bazı gömülü web görünümleri) hiç tetiklenmiyor. Artık aktif
 * slayt doğrudan scrollLeft / slayt genişliği ile hesaplanıyor — her yerde
 * çalışan, tek satırlık ve test edilebilir bir yöntem.
 *
 * Ürün detay sayfasındaki galeri de aynı desende çalışıyor
 * (bkz. sections/keefla-urun-detay-sayfasi.liquid — .kf-shot-track).
 */
(function () {
  var SWIPE_CLICK_GUARD_MS = 350;

  function initCard(card) {
    if (card.dataset.kfCardGalleryReady === '1') return;
    card.dataset.kfCardGalleryReady = '1';

    var track = card.querySelector('[data-card-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length === 0) return;

    var dots = Array.prototype.slice.call(card.querySelectorAll('[data-card-dots] .collection-sort-grid__dot'));
    var lastScrollAt = 0;

    function currentIndex() {
      if (!track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function syncDots() {
      var index = currentIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function scrollToSlide(index) {
      if (index < 0 || index >= slides.length) return;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    }

    function slideIndexForImageId(imageId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-image-id') === String(imageId)) return i;
      }
      return -1;
    }

    // Kaydırma (parmakla ya da programatik) → noktaları güncelle + swipe anını
    // not al (hemen ardından gelen click'i yutmak için).
    track.addEventListener('scroll', function () {
      lastScrollAt = Date.now();
      syncDots();
    }, { passive: true });

    // Kaydırmadan hemen sonra karta tıklanmış sayılıp ürün sayfasına
    // gidilmesin (mobilde swipe sırasında çok can sıkıcı oluyor).
    var mediaLink = card.querySelector('.collection-sort-grid__media-link');
    if (mediaLink) {
      mediaLink.addEventListener('click', function (event) {
        if (Date.now() - lastScrollAt < SWIPE_CLICK_GUARD_MS) {
          event.preventDefault();
        }
      });
    }

    // Renk kutucuğu → o rengin fotoğrafına kaydır.
    card.addEventListener('change', function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.classList.contains('collection-sort-grid__swatch-input')) return;

      var imageId = input.getAttribute('data-image-id');
      if (!imageId) return;

      var idx = slideIndexForImageId(imageId);
      if (idx !== -1) scrollToSlide(idx);
    });

    // Masaüstü: hover'da 2. fotoğraf, ayrılınca ilkine dön.
    var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (supportsHover && slides.length > 1 && card.dataset.hoverSecondImage === 'true') {
      card.addEventListener('mouseenter', function () {
        if (currentIndex() === 0) scrollToSlide(1);
      });
      card.addEventListener('mouseleave', function () {
        scrollToSlide(0);
      });
    }

    syncDots();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.collection-sort-grid__card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Filtreleme/sayfa değişimiyle sonradan eklenen kartları da yakala.
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          if (node.classList.contains('collection-sort-grid__card')) initCard(node);
          else initAll(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
